// extracted by mini-css-extract-plugin
export default {"appId":"AppManifestTargetTab__appId-MNEo6","contentBox":"AppManifestTargetTab__contentBox-lJVtR"};